import React from 'react'
import { Marker, InfoWindow} from "react-google-maps"
import { withStyles } from 'material-ui/styles'
import {path} from 'ramda'
import {isAuthenticated} from '../Redux/appRedux'
import {connect} from 'react-redux'
import {compose} from 'recompose'

const styles = {
  title: {
    marginRight: 5
  }
}

const mapStateToProps = state => ({
  isAuthenticated: isAuthenticated(state)
})

const formatEndereco = ({premisseType, premisse, number, neighbourhood}) => 
  `${premisseType} ${premisse}, ${number}, ${neighbourhood}`

class GileadeMarker extends React.Component {

  renderPrivateData(celula, classes) {
    return (
      <div>
        <span className={classes.title}>Telefone:</span>
        <span>{celula.telefoneDoLider}</span>
        <br/>
        <span className={classes.title}>Endereço:</span>
        <span>{formatEndereco(celula.endereco)}</span>
        <br/>
      </div>
    )
  }

  render() {
    const {isOpen, celula, classes, isAuthenticated, onClose, onClick} = this.props
    return (
      <Marker
        onClick={onClick}
        icon={`http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|${celula.color.replace('#', '')}`}
        key={celula.id}
        position={{ lat: celula.endereco.latitude, lng: celula.endereco.longitude }} >
        { isOpen ? <InfoWindow onCloseClick={onClose}>
          <div>
            <span className={classes.title}>Igreja:</span>
            <span>{path(['igreja', 'descricao'], celula)}</span>
            <br/>
            <span className={classes.title}>Tags:</span>
            <span>{celula.labelsDescription}</span>
            <br/>
            <span className={classes.title}>Nome:</span>
            <span>{celula.descricao}</span>
            <br/>
            <span className={classes.title}>Email:</span>
            <span>{celula.emailDoLider}</span>
            <br/>
            <span className={classes.title}>Dia/Hora:</span>
            <span>{celula.diaDaSemana}</span>
            <br/>
            { isAuthenticated ? this.renderPrivateData(celula, classes) : null }
          </div>
        </InfoWindow> : null }
      </Marker>
    )
  }
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(GileadeMarker)



// WEBPACK FOOTER //
// ./src/Components/GileadeMarker.js